import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '@/views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { pageOrder: 0 },
  },
  {
    path: '/project-concept',
    name: 'ProjectConcept',
    component: () => import('@/views/ProjectConcept.vue'),
    meta: { pageOrder: 2 },
  },
  {
    path: '/location',
    name: 'Location',
    component: () => import('@/views/Location.vue'),
    meta: { pageOrder: 3 },
  },
  {
    path: '/project-details',
    name: 'ProjectDetails',
    component: () => import('@/views/ProjectDetails.vue'),
    meta: { pageOrder: 4 },
  },
  {
    path: '/master-plans',
    name: 'MasterPlans',
    component: () => import('@/views/MasterPlans.vue'),
    meta: { pageOrder: 5 },
    redirect: {
      name: 'MasterPlansFloors',
      params: { floorId: 6 },
    },
    children: [
      {
        path: 'floors',
        component: () => import('@/views/MasterPlans/Floors.vue'),
        props: (route) => ({ floorId: parseInt(route.params.floorId) }),
        meta: { pageOrder: 0 },
        redirect: {
          name: 'MasterPlansFloors',
          params: { floorId: 6 },
        },
        children: [
          {
            path: ':floorId',
            name: 'MasterPlansFloors',
            component: () => import('@/views/MasterPlans/Floors.vue'),
          },
        ],
      },
      {
        path: 'units',
        component: () => import('@/views/MasterPlans/Units.vue'),
        props: true,
        meta: { pageOrder: 1 },
        redirect: {
          name: 'MasterPlansUnits',
          params: { unitName: 'A1' },
        },
        children: [
          {
            path: ':unitName',
            name: 'MasterPlansUnits',
            component: () => import('@/views/MasterPlans/Units.vue'),
          },
        ],
      },
      {
        path: 'compare',
        name: 'MasterPlansCompare',
        component: () => import('@/views/MasterPlans/Compare.vue'),
        meta: { pageOrder: 2 },
      },
    ],
  },
  {
    path: '/facilities',
    name: 'Facilities',
    component: () => import('@/views/Facilities.vue'),
    meta: { pageOrder: 6 },
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: () => import('@/views/Gallery.vue'),
    meta: { pageOrder: 7 },
    props: true,
    redirect: '/gallery/exterior',
    children: [
      {
        path: ':id',
        name: 'GalleryId',
        component: () => import('@/views/Gallery.vue'),
      },
    ],
  },
  {
    path: '/animation',
    name: 'Animation',
    component: () => import('@/views/Animation.vue'),
    meta: { pageOrder: 8 },
  },
  {
    path: '/vr-tour',
    name: 'VRTour',
    component: () => import('@/views/VRTour.vue'),
    meta: { pageOrder: 9 },
  },
  {
    path: '/privileges',
    name: 'Privileges',
    component: () => import('@/views/Privileges.vue'),
    meta: { pageOrder: 10 },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue'),
    meta: { pageOrder: 11 },
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
